import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="container">
        <h1>🛡️ AWS Amplify Enterprise Security Demo</h1>
        <p className="subtitle">Comprehensive Security Controls Implementation</p>
        
        <div className="features">
          <div className="feature">
            <h3>🔐 Service Control Policies</h3>
            <p>Organization-level governance preventing unauthorized deployments</p>
          </div>
          <div className="feature">
            <h3>🛡️ WAF Protection</h3>
            <p>Web Application Firewall with managed rule sets</p>
          </div>
          <div className="feature">
            <h3>🌐 CloudFront CDN</h3>
            <p>Global content delivery with security headers</p>
          </div>
          <div className="feature">
            <h3>📊 Config Monitoring</h3>
            <p>Continuous compliance monitoring and automated remediation</p>
          </div>
        </div>
        
        <div className="status">
          <h3>✅ Demo Status: Fully Operational</h3>
          <p>All security controls active and functional</p>
          <p className="build-info">Built with React • Deployed via AWS Amplify</p>
        </div>
      </div>
    </div>
  );
}

export default App;
